import { datadogRum } from '@datadog/browser-rum';
import { logger } from 'logger';
import { getDomainEnv } from 'utils/assets';
import { APP_VERSION } from 'version';
import { reactPlugin } from '@datadog/browser-rum-react';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const LOG = logger.getLogger('useDatadogInit');

export function useDatadogInit() {
  const env = getDomainEnv();
  datadogRum.init({
    applicationId: process.env.DATADOG_APP_ID ?? '',
    clientToken: process.env.DATADOG_TOKEN ?? '',
    site: 'datadoghq.com',
    service: 'mml-pwa',
    env: env,
    version: APP_VERSION.version,
    // React router plugin to track route views
    plugins: [reactPlugin({ router: true })],
    // Some analytics tracking requires manually creating page views
    // for items that are not actually routes.
    // These are created using: datadogRum.startView
    trackViewsManually: true,
    // The following are needed for older browsers or specific to rum v6
    sessionPersistence: ['cookie', 'local-storage'],
    allowFallbackToLocalStorage: true,
    // Adding these to try and mimic v7 request defaults
    propagateTraceBaggage: true,
    enablePrivacyForActionName: true,
    trackEarlyRequests: true,
    trackBfcacheViews: true,
  });
}
